import React, { useEffect, useRef } from 'react'
import styled from 'styled-components'
import profile_pic from '../assets/other_imgs/profile.png'
import waves from '../assets/other_imgs/shape-wawes.svg'
import circle from '../assets/other_imgs/shape-circle.svg'
import AOS from "aos";
import "aos/dist/aos.css";


const HomeStyles = styled.div`
    row-gap: 4rem;
    padding-top: 2rem;

    .home__data{
        row-gap: 1.5rem;
    }

    .home__title {
        text-align: center;
        font-size: var(--biggest-font-size);
        letter-spacing: .3px;
        margin-bottom: .5rem;
        
    }
    .home__blob{
        position: relative;
        width: 260px;
        height: 370px;
        background-color: var(--body-color);
        border: 2px solid var(--text-color-light);
        justify-self: center;
        border-radius: 7.25rem;
        place-items: center;
        transition: all 0.4s;
    }

    .home__profile{
        width: 230px;
        height: 340px;
        background: var(--gradient-color);
        border-radius: 6.5rem;
        overflow: hidden;
        display: flex;
        justify-content: center;
        align-items: flex-end;


        img{
            width: 250px;
        }
    }
    .home__shape-wawes,.home__shape-circle{
        position: absolute;
        opacity: .1;
    }

    .home__shape-wawes{
        width: 70px;
        left: -1.5rem;
        top: 5rem;
    }

    .home__shape-circle{
        width: 200px;
        bottom: -2rem;
        right: -4rem;
        transform: rotate(15deg);
        z-index: -1;
    }

    .home__social{
        justify-self: center;
        display: flex;
        column-gap: 1.5rem;
    }

    .home__social-link{
        font-size: 1.25rem;
        color: var(--text-color-light);
        transition: color .03s;

        &:hover{
            color: var(--title-color);
        }
        i{
            font-size: 1.5rem;
        }
    }

    .home__info{
        display: grid;
        row-gap: 2rem;
        margin-left: 1.5rem;

        .home__info-title{
            font-family: var(--body-font);
            font-size: var(--smaller-font-size);
            font-weight: 400;
            color: var(--text-color-light);
            margin-bottom: 1rem;

        }

        .home__info-description{
            font-family: var(--body-font);
            color: var(--title-color);
            font-weight: 500;
            padding-right: 4rem;


            a {
                color: var(--title-color);
            }
        }
    }
    @media screen and (max-width: 340px){
        
        .home__title{
            text-align: center;
            width: fit-content;
            margin: 0 auto;
            font-size: 1.1rem;
            letter-spacing: .3px;
            margin-bottom: 0.5rem;
            
        }
        .home__info{
            display: grid;
            row-gap: 2rem;
            margin-left: 0;

            .home__info-title{
                font-size: var(--small-font-size);
            }
            
            .home__info-description{
                font-size: var(--mormal-font-size);
                line-height: 20px;
            }
        }
    }
    @media screen and (min-width: 767px){
        display: grid;
        grid-template-columns: 1fr 2fr;
        justify-content: center;
        padding-right: 3rem;
        padding-left: 3rem;

        .home__data{
            order: 2;
        }
        .home__info:nth-child(3){
            order: 3;
        }
        .home__info{
            margin-left: 0;
            .home__info-description{
                padding-right: 0;
            }
        }
    }
    @media screen and (min-width: 1024px){
        justify-content: center;
        margin: 1rem auto 0;
        .home__info{
            margin-left: 0;
        }
    }
    @media screen and (min-width: 1048px){
        justify-content: center;
        margin: 1rem auto 0;
        .container{
            .home__info{
                margin-left: 0;
            }
        }
    }
    @media screen and (min-width: 1200px){
        .home__blob{
            width: 400px;
            height: 520px;
            border-radius: 10.6rem;
        }
        .home__profile{
            width: 350px;
            height: 460px;
            border-radius: 8.45rem;
            img{
                width: 350px;
            }
        }

        .home__shape-wawes{
            width: 100px;
            left: -4rem;
            top: 8rem;
        }
        .home__shape-circle{
            width: 250px;
            bottom: -1rem;
            right: -5rem;
        }
        .home__data{
            margin-top: 2.5rem;
        }
        .home__social{
            column-gap: 2.25rem;

        }
        .home__social-link{
            font-size: 2rem;
        }
        .home__info{
            grid-template-rows: repeat(3,fit-content);
            row-gap: 4rem;
            margin-top: 2.5rem;
        }
    }
    
`


function Home({ menuref }) {

    const currref = useRef(null);

    const scrollActive = () => {
        const scrollY = window.pageYOffset;
        const sectionHeight = currref.current.offsetHeight;
        const sectionTop = currref.current.offsetTop - 58;
        // console.log(currref.current.id);
        const sectionId = currref.current.id;
        const sectionClass = menuref.current.querySelector('.nav__menu a[href*=' + sectionId + ']');

        if (scrollY > sectionTop && scrollY <= sectionTop + sectionHeight) {
            sectionClass.classList.add('active-link');
        } else {
            sectionClass.classList.remove('active-link');
        }

    }
    useEffect(() => {
        AOS.init({
            duration: 1000,
        });
        AOS.refresh();

        window.addEventListener("scroll", scrollActive);
    }, [])
    return (
        <section className='section section__border' id='home' ref={currref}>
            <h1 className="home__title" data-aos="fade-down">
                Hi, I'm Sudhanshu Sharma <br />
                Full Stack Web Developer <br />
            </h1>
            <HomeStyles className="container grid" style={{ marginInline: 'auto' }}>
                <div className="home__data grid">

                    <div className="home__blob grid" data-aos="fade-left">
                        <div className="home__profile">
                            <img src={profile_pic} alt="profile" />
                        </div>

                        <img src={waves} alt="" className="home__shape-wawes" />
                        <img src={circle} alt="" className="home__shape-circle" />
                    </div>

                    <ul className="home__social">
                        <a href="https://www.linkedin.com/in/Sudhanshu894/" target="_blank" className="home__social-link">
                            <i className="ri-linkedin-box-line"></i>
                        </a>
                        <a href="https://github.com/Sudhanshu894" target="_blank" className="home__social-link">
                            <i className="ri-github-line"></i>
                        </a>
                        <a href="https://codepen.io/Sudhanshu057" target="_blank" className="home__social-link">
                            <i className="ri-codepen-line"></i>
                        </a>
                    </ul>
                </div>


                <div className='home__info' data-aos="fade-right">
                    <div>
                        <h3 className='home__info-title'>
                            BIOGRAPHY
                        </h3>
                        <p className='home__info-description'>
                            A Web Developer always looking forward to learn something new and creates the user friendly and simple but interactive UI websites. Good with team work and love to be a part of collaborative projects. Interested in meeting new people, Learn new skills and good problem solving.
                        </p>
                    </div>
                    <div>
                        <h3 className='home__info-title'>
                            CONTACT
                        </h3>
                        <p className='home__info-description'>
                            New Delhi,Delhi <br />
                            sidharts894@gmail.com <br />
                            <a href="https://www.linkedin.com/in/Sudhanshu894" target='_blank'>Linkedin: Sudhanshu894</a>
                        </p>
                    </div>
                    <div>
                        <h3 className="home__info-title">SERVICES
                        </h3>
                        <p className="home__info-description">
                            UI/UX Design <br />
                            Full Stack web Development <br />
                            Professionalism
                        </p>
                    </div>
                </div>
            </HomeStyles>
            <div className='resume'>
                <a href="https://drive.google.com/file/d/18dB49NCTcEKterm_x8jVg2zvcSnib_mc/view?usp=share_link" target={"_blank"}>
                    <button>
                        Resume
                        <i className="ri-profile-line"></i>
                    </button>
                </a>
            </div>
        </section >
    )
}

export default Home